import pickBy from 'lodash/pickBy'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import parseURLSearch from '~utils/parse-url-search'

Vue.use(VueI18n)

const LOCALE_MAP: {
  [key: string]: string;
} = {
  AT: 'de',
  DE: 'de',
  CH: 'de',
  GB: 'en',
  FR: 'fr',
  IT: 'it',
  NL: 'nl',
}

const mappedLocaleOrEnglish = (language: string) => LOCALE_MAP[language] || 'en'

export default (store: any, availableLocales: string[] | null = null): VueI18n => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  let { messages } = require('./languages/index.ts')

  if (availableLocales) {
    messages = pickBy(messages, (value, key) => availableLocales.includes(key))
  }

  const locale = mappedLocaleOrEnglish(parseURLSearch().language)
  document.documentElement.lang = locale

  const i18n = new VueI18n({
    locale,
    fallbackLocale: 'en',
    messages,
  })

  // eslint-disable-next-line no-param-reassign
  store.$i18n = i18n

  return i18n
}
